import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getEasternNowParts } from '../../../helpers/usEasternTime';
import { getCountdown } from './market_open_close';

const easternCountdownClock = () => {
  const parts = getEasternNowParts();
  return {
    day: parts.dayOfWeek,
    hours: parts.hour,
    minutes: parts.minute,
    seconds: 59 - new Date().getSeconds(),
  };
};

const MarketOpenCloseStatus = () => {
  const [openClose, setOpenClose] = useState(
    getCountdown(easternCountdownClock())
  );
  useEffect(() => {
    const runner = setInterval(() => {
      setOpenClose(getCountdown(easternCountdownClock()));
    }, 1000);
    return () => clearInterval(runner);
  }, []);

  return (
    <Wrapper id={'market-open-close'}>
      <span className={'ion-android-time'}></span> <span>{openClose[1]}</span>{' '}
      <span>{openClose[0]}</span>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: inline;
  gap: 4px;
`;

const ClockData = styled.span`
  display: inline-block;
  /* flex-direction: column; */
`;

export default MarketOpenCloseStatus;
